module.exports = __webpack_public_path__ + "a2448c2b2148c6af7205cae033cfadf6.pdf";